import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import Label from '../../typography/Label';
import AlertIcon from '../../icons/utility/AlertIcon';
import InputError from '../InputError';
import withFocus from '../../hocs/withFocus';
import withFormErrors from '../../hocs/withFormErrors';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
import CaretIcon from '../../icons/utility/CaretIcon';
export const DefaultSelect = React.forwardRef(({ name, defaultValue, displayName, placeholder = '', required = false, size = 'large', disabled = false, centerLabel = false, showErrMessage = true, readOnly = false, isFocused, handleBlur, handleFocus, onBlur, errorId, errorMessage, styles, wrapperStyles, maxLength, autoCapitalize, options, className = '', autoCorrect, ...rest }, ref) => {
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const { borders, sizing: { widths }, inputs: { base, shape, size: sizeStyles, disabled: disabledInputStyles, utilityIconStyles }, utility: { size: { fullWidthStyles } } } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...(!errorId && { marginBottom: 'regular' })
    });
    const mergedStyles = {
        ...base,
        ...shape.pill,
        ...sizeStyles.regular,
        ...fullWidthStyles,
        ...(disabled && disabledInputStyles),
        ...(!isFocused && borders.variant.secondary),
        // error styles MUST come after active styles to override them
        ...(!!errorId && borders.error),
        ...marginStyles,
        ...{
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none'
        },
        ...styles
    };
    const mergedWrapperStyles = {
        width: widths.input[size],
        position: 'relative',
        ...wrapperStyles
    };
    const iconStyle = {
        ...utilityIconStyles,
        ...(!displayName && { top: '2rem' })
    };
    return (React.createElement("div", { style: mergedWrapperStyles },
        displayName && (React.createElement(Label, { htmlFor: name, required: required, disabled: disabled, centered: !!centerLabel }, displayName)),
        React.createElement("select", { autoCorrect: autoCorrect, defaultValue: defaultValue, name: name, id: name, required: required, disabled: disabled, style: mergedStyles, "aria-invalid": !!errorId, "aria-describedby": errorId, "aria-readonly": readOnly, ref: ref, autoCapitalize: autoCapitalize, className: className, ...rest, ...focusHandlers }, options.map((option, index) => (React.createElement("option", { key: `${index}-${option.value}`, value: option.value }, option.label)))),
        errorId ? (React.createElement(AlertIcon, { size: "utility", styles: iconStyle })) : (React.createElement(CaretIcon, { size: "utility", direction: 'down', styles: { pointerEvents: 'none', ...iconStyle }, disabled: disabled })),
        showErrMessage && errorMessage && (React.createElement(InputError, { id: errorId }, errorMessage))));
});
export default withFormErrors(withFormProps(withFocus(DefaultSelect)));
//# sourceMappingURL=index.js.map